import apiCall, { apiCall2 } from "components/Api/api";
import { getFormattedDateTime } from "components/Api/common";
import { handleError } from "components/Api/handleError";
import { fetchAllComments } from "components/SharedSafari/utils/sharedSafariUtils";
import { useAuth } from "provider/AuthContext";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom"

const CommentForm = ({ setLoading }) => {
    const { safariSlug } = useParams();
    const navigate = useNavigate();
    const { logout, userProfile } = useAuth();
    const { commentsUrl, safariViewData, userComments, sharedSafariDispatch } = useSharedSafariContext();
    const [comment, setComment] = useState('');
    const [posting, setPosting] = useState(false);
    const [error, setError] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!comment.trim()) {
            setError("Comment cannot be empty.");
            return;
        }
        try {
            setPosting(true);
            setError('');
            const formData = new FormData();
            formData.append('comment', comment);

            // Post Comment
            const response = await apiCall({
                url: `sharesafari/${safariSlug}/comment`,
                method: "POST",
                data: formData,
            });
            if (response.status !== 200) {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
            const apiData = response.data;
            //check error after 200/ok
            if (response.status === 200 || response.status === 201) {
                if (apiData?.errors) {
                    const errors = apiData.errors;

                    Object.keys(errors).forEach((key) => {
                        const errorMessages = errors[key];
                        const firstErrorMessage = errorMessages[0]; // Take only the first error
                        setError((prevData) => ({
                            ...prevData,
                            [key]: firstErrorMessage,
                        }));
                    });

                    sharedSafariDispatch({
                        type: "SET_SHARED_SAFARI_VIEW_ERROR",
                        payload: errors,
                    });

                    return; // Stop further execution if there are errors
                }
                setComment('');  // Clear
                
                const current_date = getFormattedDateTime();

                const newComments = {
                    id: Math.floor(10000 + Math.random() * 90000),
                    version: 1,
                    parent_id: null,
                    safari_operator_id: null,
                    comment: comment,
                    date_time: current_date,
                    user: {
                        username: userProfile?.username,
                        name: userProfile?.name,
                        is_mobile_no_verified: userProfile?.is_mobile_no_verified,
                        mobile_no_verified_at: userProfile?.mobile_no_verified_at,
                        email: userProfile?.email,
                        is_safari_operator: userProfile?.is_safari_operator,
                        user_handle: userProfile?.user_handle,
                        gender: userProfile?.gender,
                        account_type: userProfile?.account_type,
                        gender_privacy: userProfile?.gender_privacy,
                        email_privacy: userProfile?.email_privacy,
                        status: userProfile?.status,
                        profile_display_image: userProfile?.profile_display_image,
                        cover_display_image: userProfile?.cover_display_image,
                        display_name: userProfile?.display_name,
                        is_followed: userProfile?.is_followed,
                        user_activity_count: userProfile?.user_activity_count,
                        operator_slug: userProfile?.operator_slug,
                        user_followers_count: userProfile?.user_followers_count,
                        user_followings_count: userProfile?.user_followings_count,
                        will_flag: true,
                        replies: []

                    }
                }

                const updatedComments = [newComments, ...userComments];


                sharedSafariDispatch({
                    type: "SET_SHARED_SAFARI_VIEW_USERS_COMMENTS",
                    payload: updatedComments,
                });


            } else {
                setError("Failed to post comment. Please try again.");
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
            handleError(error, logout, navigate);
        } finally {
            setPosting(false);
        }
    };


    return (

        <form id="comment-form" onSubmit={handleSubmit}>
            <input type="hidden" name="_csrf-frontend" value="TOKEN_HERE" />
            <div className="comments-persons px-4 pt-4">
                <div className="postcomment d-flex gap-3">
                    <div className="avatar">
                        <Link to={`/profile/user/${userProfile?.user_handle}`}>
                            <Image
                                src={userProfile?.profile_display_image || "/img/user.png"}
                                alt=""
                                className="me-1 d-xl-inline-flex rounded-circle bg-info"
                                width="30"
                                height="30"
                            />
                        </Link>
                    </div>
                    <div className="text-area">
                        <div className="mb-3 field-sharesafaricommentform-comment required">
                            <textarea
                                id="sharesafaricommentform-comment"
                                className="form-control w-100"
                                name="ShareSafariCommentForm[comment]"
                                rows="5"
                                placeholder="Write a comment..."
                                value={comment}
                                onChange={(e) => {
                                    setComment(e.target.value);
                                    setError('')
                                }}
                            ></textarea>
                            {error && <div className="invalid-feedback d-block">{error}</div>}
                        </div>
                    </div>
                </div>
            </div>

            <div className="comments-persons px-4 pt-2">
                <div className="row justify-content-center">
                    <div className="col-lg-12 col-xl-8">
                        <div className="post_text padding_ad">
                            <p>
                                Commenting on this thread will notify all event attendees and will also be visible to
                                everyone viewing the event.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-4">
                        <div className="comment_button float-end mb-lg-0 mb-3">
                            <button type="submit" className="post-comment" disabled={posting}>
                                {posting ? "Posting..." : "Post Comment"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default CommentForm